import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultWordInfo } from '../interfaces/WordIf'
import { useAuth } from './useAuth'
import { useApiUrl } from './useApiUrl'

interface C407WordUpdateProps {
  execWordUpdate: (
    deviceId: string,
    old_wordText: string,
    wordText: string,
    language?: string,
  ) => Promise<ResultWordInfo>
  loading: loadStatus
}

// C407 強調単語更新API呼出
export const useC407WordUpdate = (): C407WordUpdateProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const { buildDeviceUrl } = useApiUrl()
  const execWordUpdate = async (
    deviceId: string,
    old_wordText: string,
    wordText: string,
    language = 'ja',
  ) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        return { success: false, message: errorMsg.SESSION_ERROR }
      }

      // ヘッダ作成
      const headers = {
        ...axiosDefaultHeader,
        Authorization: `Bearer ${jwt}`,
      }

      // ボディ作成
      const body = {
        old_word_text: old_wordText,
        word_text: wordText,
        language,
      }

      const response = await axios.put(
        buildDeviceUrl(deviceId, apiUrl.wordsPath), 
        body,
        {
          headers,
          validateStatus: () => true,
        },
      )

      setLoading(loadStatus.LOADED)
      if (response.status === apiStatus.SUCCESS) {
        return { success: true, info: response.data }
      }
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execWordUpdate, loading }
}